export function getTranslationsPage9(newTransactionInfo, localizedStrings) {
  newTransactionInfo.amountdue.elementConfig.label =
    localizedStrings.applicationpage.amountdue;
  newTransactionInfo.emailaddress1.elementConfig.label =
    localizedStrings.applicationpage.receiptemail;
  return newTransactionInfo;
}
